import Vue from 'vue';

// TODO: Solve this through composition in V3 Vue!

export default Vue.extend({
  props: {
    errors: { default: undefined, type: [String, Array] },
    messages: { default: undefined, type: [String, Array] },
    label: { default: undefined, type: String },
    type: { default: undefined, type: String },
    required: { default: false, type: Boolean },
  },
  data: () => ({
    innerErrors: undefined as string | string[] | undefined,
    innerMessages: undefined as string | string[] | undefined,
    innerLabel: undefined as string | undefined,
    innerType: undefined as string | undefined,
    innerRequired: false as boolean,
  }),
  watch: {
    errors: {
      immediate: true,
      handler() {
        this.$set(this, 'innerErrors', this.errors);
      },
    },
    messages: {
      immediate: true,
      handler() {
        this.$set(this, 'innerMessages', this.messages);
      },
    },
    label: {
      immediate: true,
      handler() {
        this.$set(this, 'innerLabel', this.label);
      },
    },
    type: {
      immediate: true,
      handler() {
        this.$set(this, 'innerType', this.type);
      },
    },
    required: {
      immediate: true,
      handler() {
        this.$set(this, 'innerRequired', this.required);
      },
    },
  },
  methods: {
    setErrors(errors: string | string[] | undefined) {
      this.innerErrors = errors;
    },
    setMessages(messages: string | string[] | undefined) {
      this.innerMessages = messages;
    },
    setLabel(label: string) {
      this.innerLabel = label;
    },
    setRequired(required: boolean) {
      this.innerRequired = required;
    },
    setType(type: string) {
      this.innerType = type;
    },
    getErrors() {
      return this.innerErrors;
    },
    getMessages() {
      return this.innerMessages;
    },
    getLabel() {
      return this.innerLabel;
    },
    getRequired() {
      return this.innerRequired;
    },
    getType() {
      return this.innerType;
    },
  },
});
